import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const token = ref(localStorage.getItem('auth_token') || null)

  // Load user from localStorage on init
  const storedUser = localStorage.getItem('user')
  if (storedUser) {
    try {
      user.value = JSON.parse(storedUser)
    } catch (e) {
      console.error('Failed to parse stored user:', e)
    }
  }

  const isAuthenticated = computed(() => !!token.value && !!user.value)

  const hasRole = (role) => {
    if (!user.value) return false
    return user.value.roles?.some(r => r.name === role || r === role) || false
  }

  const hasAnyRole = (roles) => {
    if (!user.value) return false
    return roles.some(role => hasRole(role))
  }

  const setAuth = (userData, authToken) => {
    user.value = userData
    token.value = authToken
    localStorage.setItem('auth_token', authToken)
    localStorage.setItem('user', JSON.stringify(userData))
  }

  const clearAuth = () => {
    user.value = null
    token.value = null
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user')
  }

  return {
    user,
    token,
    isAuthenticated,
    hasRole,
    hasAnyRole,
    setAuth,
    clearAuth,
  }
})

